import { render, staticRenderFns } from "./purStockchaseRefundList.vue?vue&type=template&id=80affbbc&scoped=true"
import script from "./purStockchaseRefundList.vue?vue&type=script&lang=js"
export * from "./purStockchaseRefundList.vue?vue&type=script&lang=js"
import style0 from "./purStockchaseRefundList.vue?vue&type=style&index=0&id=80affbbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80affbbc",
  null
  
)

export default component.exports